<template>
  <div>
    <div class="row" style>
      <div class="col-sm">
        <h1>Blood sugar measurements</h1>
      </div>
      <div class="col-sm">
        <button
          id="measurement-create-button"
          class="btn btn-primary float-sm-right"
          v-on:click="moveToCreateView()"
        >+ New measurement</button>
      </div>
    </div>

    <div id="measurement-main-content" v-if="store.getBloodSugarMeasurementCount() > 0">
      <bloodSugar-list />
    </div>

    <div
      id="measurement-info"
      v-if="store.getBloodSugarMeasurementCount() == 0"
    >This page is all about blood sugar measurements.</div>
    <div id="no-measurements-info" v-if="store.getBloodSugarMeasurementCount() == 0">
      <p>
        However, you have no blood sugar measurements yet.
        <br />You can add the first one right now.
      </p>
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import BloodSugarList from "@/components/BloodSugarList.vue";

export default {
  name: "BloodSugarMeasurementView",
  components: {
    BloodSugarList
  },
  data: function() {
    return {
      store: store
    };
  },
  computed: {},
  created: function() {},
  mounted: function() {},
  methods: {
    moveToCreateView() {
      // this.store.state.bloodSugarView.cancelRoute = "bloodSugar";
      this.$router.push({
        name: "blood-sugar.create"
      });
    }
  }
};
</script>

<style scoped>
#measurement-info {
  font-size: 200%;
  color: #111;
}

#no-measurements-info {
  font-size: 145%;
  color: #333;
}

.main-content-row {
  padding-top: 1rem;
}

.nav-tabs {
  margin-top: 1em;
}

.nav-tabs .nav-link {
  color: gray;
  cursor: pointer;
}
</style>